import { ReactNode } from 'react';

import { WindowModal } from '@app/components/Modal/WindowModal';

interface UpSellingModalProps {
  children: ReactNode;
  isOpen: boolean;
  onRequestClose?: () => void;
}

export default function UpSellingModal({ children, isOpen, onRequestClose }: UpSellingModalProps) {
  return (
    <WindowModal isOpen={isOpen} maxWidth="sm" onRequestClose={onRequestClose}>
      {children}
    </WindowModal>
  );
}
